import { useState } from "react";

export const useInput = (initialValue) => {
    const [value, setValue] = useState(initialValue);

    return {
        value,
        setValue,
        reset: () => setValue(""),
        bind: {
            value,
            updateOnChange: (n, v) => {
                setValue(v);
            },
        },
    };
};

/*export const useValidation = (value, attribute) => {
    const [error, setError] = useState({  
        isValid: validation.isValid, 
        errorMsg: validation.errorMsg,
    });

    return {

    }
};*/
